// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_BASE_URL_Append: 'https://gasbalance-dev.tengizchevroil.com',
  apiTokenScope: 'https://gasbalance-dev.tengizchevroil.com/user_impersonation',
  calAngularConfig: {
    autoSignIn: true,
    popupForLogin: true,
    cacheLocation: 'localStorage',
    instance: 'https://login.microsoftonline.com/',
    tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
    clientId: '5d2ea035-2c03-43da-888b-435414ad2fab',
    redirectUri: 'https://gasbalance-dev.tengizchevroil.com',
    oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
    graphScopes: ['User.Read', 'Directory.Read.All', 'Group.Read.All'],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
